// vendor
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import Spinner from 'react-spinkit';

// app
import StudentSteps from '../../common/StudentSteps';
import ConfirmPageTable from './ConfirmRankingTable';
import * as runActions from '../../../actions/runsActionCreators';
import * as loginActions from '../../../actions/loginActionCreators';
import * as studentActions from '../../../actions/studentsActionCreators';
import * as courseActions from '../../../actions/coursesActionCreators';

class ConfirmPage extends React.Component {

  state = {
    runName: null
  }

  componentWillMount() {
    const {
      run,
      student,
      courses,

      studentActions,
      runActions,
      courseActions
    } = this.props;

    runActions.getAllRankPreferences();

    if (!run.id) {
      runActions.getRun();
    }

    if (!student.id) {
      studentActions.getStudent()
      .then(res => {
          const runName = localStorage.getItem('run');
          if (res.target_course_units == null) {
            browserHistory.push(`/rank/${runName}/start`);
          }
        });
    }

    if (courses.length === 0) {
      courseActions.getAllCourses();
    }
  }

  componentDidMount() {
    const runName = localStorage.getItem('run');

    this.setState({ runName });
  }

  prepareRankedClassesData = () => {
    const { student, courses } = this.props;
    // console.log(student);
    const { preferences } = student;

    const ranksWithCourse = preferences.map((p) => {
      const rankCourse = courses.find((c) => c.id === p.course);

      return {
        ...p,
        rankCourse
      }
    });
    
    return ranksWithCourse;
  }

  handleLogout = () => {
    const { loginActions = {} } = this.props;
    const isEmulating = sessionStorage.getItem('emulating')
    const runName = localStorage.getItem('run');

    loginActions.logoutAndRedirect().then(() => {
      if (isEmulating) return browserHistory.push(`/administer/${runName}`);
      browserHistory.push(`/rank/${runName}/login`);
    });
  }

  renderConfirmSubtitle = () => (
    <Col md={9}>
      <div className="page-subtitle mt-0">You have successfully submitted your rankings</div>
    </Col>
  );

  renderLogoutButton = () => (
    <Col md={3}>
      <button
        onClick={this.handleLogout}
        className="pull-right btn btn-width-auto btn-primary"
      >
        LOG OUT
      </button>
    </Col>
  );

  renderLoadingSpinner = () => (
    <div className="spinner-box">
      <Spinner spinnerName="three-bounce" className="mt-4" />
    </div>
  );

  render() {
    const { run, student, courses } = this.props;

    const isLoading = !run.id || !student.id || courses.length === 0;

    const rankedClasses = !isLoading && this.prepareRankedClassesData();

    return (
      <div>
        <Row>
          <Col md={12}>
            <div>
              <StudentSteps
                active={4}
              />
            </div>
          </Col>
        </Row>
        <Row>
          {this.renderConfirmSubtitle()}
          {this.renderLogoutButton()}
        </Row>
        <Row>
          <Col md={9} className="height-auto mb-4">
            {isLoading ? this.renderLoadingSpinner() : <ConfirmPageTable values={rankedClasses} />}
          </Col>
        </Row>
      </div>
    )
  }
}

ConfirmPage.propTypes = {
  run: PropTypes.object
};

const mapStateToProps = (state) => ({
  run: state.run,
  student: state.student,
  courses: state.courses
});

const mapDispatchToProps = (dispatch) => ({
  runActions: bindActionCreators(runActions, dispatch),
  loginActions: bindActionCreators(loginActions, dispatch),
  studentActions: bindActionCreators(studentActions, dispatch),
  courseActions: bindActionCreators(courseActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmPage);



// WEBPACK FOOTER //
// ./src/components/rank/ConfirmPage/index.js